import * as h2Api from '../h2Api'

export const LOAD_TENANT_INFO = 'EDUCATOR_LOAD_TENANT_INFO'

export const getTenantInfo = () => dispatch => {
  return dispatch(h2Api.get(`/tenant/info`)({ type: LOAD_TENANT_INFO }))
}
